import Page from "components/Page";
import React, { useEffect, useState } from "react";
import styles from "./SystemInstruction.module.scss";
import { withTranslation } from "react-i18next";
import constants from "./../../../../constants";
import Text from "components/Text";
import Card from "components/Card";
import Input from "components/Input";
import { testNumberRegexCheckForZeroToOne } from "utils";
import { cloneDeep } from "lodash";
import {
  useSystemInformation,
  useUpdateSystemInstructionMutation,
} from "repositories/ai-assistant-repository";
import toast from "react-hot-toast";
import Loader from "components/Loader";

function ManageSystemInstruction({ history, t }) {
  const [formData, setFormData] = useState({
    temperature: "",
    instruction: "",
    historyNotes: "",
  });
  const [errors, setErrors] = useState({});
  const [showLoader, setshowLoader] = useState(false);
  const { isLoading, data } = useSystemInformation();
  const updateSystemInstaructionMutation = useUpdateSystemInstructionMutation();

  useEffect(() => {
    if (data) {
      setFormData({
        temperature: data?.temperatureControl || "",
        instruction: data?.systemInstruction || "",
        historyNotes: data?.note || "",
      });
    }
  }, [data]);

  const goBack = () =>
    history.push({ pathname: constants.routes.aiAssistant.aiSetting });

  const handleTemperatureChange = (e) => {
    if (testNumberRegexCheckForZeroToOne(e.target.value)) {
      setFormData({
        ...formData,
        temperature: e.target.value,
      });
    } else {
      const errorsData = cloneDeep(errors);
      errorsData.temperature = t(
        "aiAssistant.SystemInstructionForm.validTemperatureValue"
      );
      setErrors(errorsData);
      return !Object.values(errorsData).some((err) => !!err);
    }
  };

  const handleInstructionChange = (e) => {
    setFormData({
      ...formData,
      instruction: e.target.value,
    });
  };

  const handleHistoryNotesChange = (e) => {
    setFormData({
      ...formData,
      historyNotes: e.target.value,
    });
  };

  const isValidEvent = () => {
    const errorsData = cloneDeep(errors);

    const temperatureValue = formData?.temperature || "";
    if (!temperatureValue.toString().trim().length) {
      errorsData.temperature = t(
        "aiAssistant.SystemInstructionForm.temperatureEmptyErrorMsg"
      );
    } else {
      delete errorsData.temperature;
    }

    const instructionValue = formData?.instruction || "";
    if (!instructionValue.toString().trim().length) {
      errorsData.instruction = t(
        "aiAssistant.SystemInstructionForm.instructionEmptyErrorMsg"
      );
    } else {
      delete errorsData.instruction;
    }

    setErrors(errorsData);
    return !Object.values(errorsData).some((err) => !!err);
  };

  const updateInstruction = async () => {
    if (!isValidEvent()) return;
    setshowLoader(true);
    try {
      const _data = {
        Id: data?.id,
        TemperatureControl: formData?.temperature,
        SystemInstruction: formData?.instruction,
        Note: formData?.historyNotes,
      };
      const resp = await updateSystemInstaructionMutation.mutateAsync(_data);
      toast.success(resp);
      goBack();
    } catch (e) {
      toast.error(e.message);
    } finally {
      setshowLoader(false);
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <Page
        onBack={() => goBack()}
        className={styles["global-main-page"]}
        title={t("aiAssistant.managementInstruction")}
      >
        <Text size="14px" weight="300" color="#000000" className="mb-4">
          {t("aiAssistant.aiAssistSubheading")}
        </Text>
        <div className={styles["new-instruction-messages"]}>
          <Card radius="10px" className={styles.instruction_card}>
            <div className={styles.card_content_container}>
              <Input
                Title={t(
                  "aiAssistant.SystemInstructionForm.temperatureControl"
                )}
                Type="number"
                Placeholder="Enter"
                Name="temperature"
                HandleChange={handleTemperatureChange}
                Error={
                  !formData?.temperature && errors.temperature
                    ? errors.temperature
                    : ""
                }
                Value={formData?.temperature || ""}
              />
              <div className="c-field">
                <label>
                  {t("aiAssistant.SystemInstructionForm.systemInstruction")}
                </label>
                <textarea
                  className="c-form-control"
                  name="instruction"
                  maxLength="5000"
                  placeholder="Enter"
                  rows="10"
                  onChange={handleInstructionChange}
                  value={formData?.instruction || ""}
                ></textarea>
                {!formData?.instruction && errors.instruction && (
                  <span className="error-msg">{errors.instruction}</span>
                )}
              </div>
              <div className="c-field">
                <label>
                  {t("aiAssistant.SystemInstructionForm.historyNotes")}
                </label>
                <textarea
                  className="c-form-control"
                  name="historyNotes"
                  maxLength="5000"
                  placeholder="Enter"
                  onChange={handleHistoryNotesChange}
                  value={formData?.historyNotes || ""}
                ></textarea>
                {!formData?.historyNotes && errors.historyNotes && (
                  <span className="error-msg">{errors.historyNotes}</span>
                )}
              </div>
              <button
                className="button  button-round button-shadow mr-3"
                onClick={() => updateInstruction()}
                disabled={showLoader}
              >
                {t("save")}
              </button>
              <button
                className="button  button-round  button-border button-dark"
                onClick={() => goBack()}
              >
                {t("cancel")}
              </button>
            </div>
          </Card>
        </div>
      </Page>
    </>
  );
}

export default withTranslation()(ManageSystemInstruction);
